export enum ResourceTabsType {
  Rooms = "Rooms",
  Desks = "Desks",
  Equipments = "Equipments",
  Misc = "Misc",
}
